export default __webpack_public_path__ + "e7c36b47e6cec9d98046c1c0c2e4e89c.ttf";